<template>
  <div>
    <el-dialog
      :title="type == 'rosterDetail' ? '确认花名册数据' : '确认经营数据'"
      :visible.sync="addDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :append-to-body="true"
      width="400px"
      @close="addDialogVisibleClose"
    >
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-width="auto"
        v-if="type == 'rosterDetail'"
      >
        <el-form-item label="年份" prop="year" :key="form.year">
          <el-date-picker
            v-model="form.year"
            type="year"
            value-format="yyyy"
            placeholder="选择年"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="季度" prop="quarter" :key="form.quarter">
          <el-select v-model="form.quarter" placeholder="请选择季度">
            <el-option
              v-for="item in options"
              :key="item.label"
              :label="item.label"
              :value="item.label"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="提报人" prop="informant">
          <el-input
            v-model="form.informant"
            placeholder="请输入提报人"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系人电话" prop="contactPhone">
          <el-input
            v-model="form.contactPhone"
            placeholder="请输入联系人电话"
            maxlength="11"
          ></el-input>
        </el-form-item>
      </el-form>
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-width="auto"
        v-if="type == 'reportFormsDetail'"
      >
        <el-form-item label="年份" prop="year" :key="form.year">
          <el-date-picker
            v-model="form.year"
            type="year"
            value-format="yyyy"
            placeholder="选择年"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="季度" prop="quarter" :key="form.quarter">
          <el-select v-model="form.quarter" placeholder="请选择季度">
            <el-option
              v-for="item in options"
              :key="item.label"
              :label="item.label"
              :value="item.label"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="填报人" prop="informantSignature">
          <el-input
            v-model="form.informantSignature"
            placeholder="请输入填报人"
          ></el-input>
        </el-form-item>
        <el-form-item label="负责人" prop="principalSignature">
          <el-input
            v-model="form.principalSignature"
            placeholder="请输入负责人"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button
          size="small "
          type="primary"
          :loading="submitLoading"
          @click="onSubmit('form')"
          >确 认</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import MyTable from "@/components/Table";

export default {
  //import引入组件才能使用
  components: {
    MyTable,
  },
  props: {
    visible: Boolean,
    inventory: null,
    type: null,
  },
  data() {
    let validateconPhone = (rule, value, callback) => {
      //使用正则表达式进行验证手机号码

      if (!/^1[3456789]\d{9}$/.test(value)) {
        callback(new Error("手机号不正确"));
      } else {
        callback();
      }
    };
    return {
      addDialog: false,
      tableData: [],
      tableHeight: "500",
      genMateResult: false,
      userInfo: {},
      form: {},
      rules: {
        year: [{ required: true, message: "请选择年份", trigger: "blur" }],
        quarter: [{ required: true, message: "请选择季度", trigger: "blur" }],
        informantSignature: [
          { required: true, message: "请输入填报人", trigger: "blur" },
        ],
        informant: [
          { required: true, message: "请输入填报人", trigger: "blur" },
        ],
        principalSignature: [
          { required: true, message: "请输入负责人", trigger: "blur" },
        ],
        contactPhone: [
          { required: true, message: "请输入联系人电话", trigger: "blur" },
          { validator: validateconPhone, trigger: "blur" },
        ],
      },

      options: [
        {
          label: "1",
        },
        {
          label: "2",
        },
        {
          label: "3",
        },
        {
          label: "4",
        },
      ],

      submitLoading: false,
    };
  },
  // 计算属性
  computed: {},
  // 监听data中的数据变化
  watch: {
    visible(val) {
      this.addDialog = val;
      if (val) {
      }
    },
  },
  // 生命周期：挂载完成时（可以访问DOM元素）
  mounted() {
    this.userInfo = JSON.parse(window.localStorage.getItem("userInfo"));
    if (this.type == "rosterDetail") {
      this.$set(this.form, "informant", this.userInfo.cname);
      this.$set(this.form, "contactPhone", this.userInfo.tel);
    }
    if (this.type == "reportFormsDetail") {
      this.$set(this.form, "informantSignature", this.userInfo.cname);
    }
  },
  // 方法集合
  methods: {
    //查看失败名单
    openFailureList() {},
    addDialogVisibleClose() {
      this.form = {};
      this.$emit("close");
    },
    //确认发放
    onSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) return;
        this.$emit("onSubmit", this.form);
        this.addDialogVisibleClose();
      });
    },
  },
};
</script>
<style lang='less' scoped>
.title {
  .label {
    display: inline-block;
    margin-top: 15px;
    width: 33%;
  }
}
</style>